var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      staticStyle: {
        padding: "30px 15px 30px 15px",
        "background-color": "#fff",
        margin: "0"
      }
    },
    [
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-title" }, [
                  _vm._v("Terms and Conditions")
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "16px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "This Website and its contents are owned or licensed by UNIFI AUSTRALIA Pty Ltd (ACN 669 133 377)\n(UNIFI, we, us or our).\n          "
                  )
                ]),
                _vm._v(" "),
                _c("br")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  {
                    staticClass: "about-unifi-para font-w400 mt-12 t-underline"
                  },
                  [_vm._v("AGREEMENT TO TERMS AND CONDITIONS\n          ")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "To the maximum extent permitted by law, these terms and conditions govern the use of this Website, the\nplacement of any Reservations and the purchase of any Services via this Website. We may amend these\nTerms and Conditions from time to time and if any part of them is illegal or unenforceable at law, it may\nbe severed and the remaining Terms and Conditions will continue in full force and effect. "
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  {
                    staticClass: "about-unifi-para font-w400 mt-12 t-underline"
                  },
                  [
                    _vm._v(
                      "AMENDMENTS TO THESE TERMS AND CONDITIONS\n          "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "For future orders of our Services and Reservations that You place with us, these Terms and Conditions\nmay be different. We recommend that you read these Terms and Conditions carefully each time You visit\nour Website, order our Services or place a Reservation. We will not change any Terms and Conditions for\nan existing Services order or a Reservation that we have accepted; the Terms and Conditions that will\napply to the Reservation or Service are the Terms and Conditions that applied at the time You placed the\nReservation or ordered the Service. "
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  {
                    staticClass: "about-unifi-para font-w400 mt-12 t-underline"
                  },
                  [_vm._v("DEFINITIONS\n          ")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v("In these Terms and Conditions: ")
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("li", { staticClass: "about-unifi-para font-w400" }, [
                  _c("span", [
                    _vm._v("• "),
                    _c("span", { staticClass: "font-w700 t-italic" }, [
                      _vm._v("Available Properties")
                    ]),
                    _vm._v(
                      " means residential or commercial properties offered for sale Prospective\nProperty Purchasers by Agents, as agents of the registered proprietors of those properties."
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "about-unifi-para font-w400" }, [
                  _c("span", [
                    _vm._v("• "),
                    _c("span", { staticClass: "font-w700 t-italic" }, [
                      _vm._v("Claim")
                    ]),
                    _vm._v(
                      " means any claim, action, proceeding, loss, damage, suit, cause of action, demand, cost,\nexpense or liability, brought, made or recovered against a person, howsoever arising, whether: "
                    )
                  ]),
                  _vm._v(" "),
                  _c("ul", [
                    _c("li", { staticClass: "about-unifi-para font-w400" }, [
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v("a) in contract, tort or otherwise; or ")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "about-unifi-para font-w400" }, [
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v(
                          "b) presently ascertained, immediate, future or contingent. "
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "about-unifi-para font-w400" }, [
                  _c("span", [
                    _vm._v("• "),
                    _c("span", { staticClass: "font-w700 t-italic" }, [
                      _vm._v("Co-Agent")
                    ]),
                    _vm._v(
                      " means a third party agent who has been appointed to sell or otherwise deal with an\nAvailable Property on behalf of the registered proprietor."
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "about-unifi-para font-w400" }, [
                  _c("span", [
                    _vm._v("• "),
                    _c("span", { staticClass: "font-w700 t-italic" }, [
                      _vm._v(
                        "Commercialise in relation to Intellectual Property Rights,"
                      )
                    ]),
                    _vm._v(" means to:")
                  ]),
                  _vm._v(" "),
                  _c("ul", [
                    _c("li", { staticClass: "about-unifi-para font-w400" }, [
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v(
                          "a) manufacture, sell, hire or otherwise exploit a product or process, that incorporates any of\nthe Intellectual Property Rights;  "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "about-unifi-para font-w400" }, [
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v(
                          "b) provide a service using any of those Intellectual Property Rights; "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "about-unifi-para font-w400" }, [
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v(
                          "c) license any third party to do any of those things, regardless of whether any revenue is\ngenerated."
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "about-unifi-para font-w400" }, [
                  _c("span", [
                    _vm._v("• "),
                    _c("span", { staticClass: "font-w700 t-italic" }, [
                      _vm._v("Confidential Information")
                    ]),
                    _vm._v(
                      " means information concerning UNIFI or any of its Related Bodies\nCorporate, including details of:"
                    )
                  ]),
                  _vm._v(" "),
                  _c("ul", [
                    _c("li", { staticClass: "about-unifi-para font-w400" }, [
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v(
                          "a) any past, current or prospective purchasers of residential or commercial properties;  "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "about-unifi-para font-w400" }, [
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v("b) any suppliers, contractors or agents; ")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "about-unifi-para font-w400" }, [
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v(
                          "c) business dealings, methodologies, marketing techniques or market analysis; "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "about-unifi-para font-w400" }, [
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v(
                          "d) financial arrangements with purchasers, suppliers, contractors or agents; "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "about-unifi-para font-w400" }, [
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v(
                          "e) information disclosed on the Property Platform; and  "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "about-unifi-para font-w400" }, [
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v(
                          "f) any other information that is by its nature confidential, is reasonably designated by UNIFI\nas confidential or which You know or ought to know is confidential, but does not include\ninformation: "
                        )
                      ]),
                      _vm._v(" "),
                      _c("ul", [
                        _c(
                          "li",
                          { staticClass: "about-unifi-para font-w400" },
                          [
                            _c(
                              "span",
                              { staticStyle: { "margin-left": "20px" } },
                              [
                                _vm._v(
                                  "i. in the public domain, unless it came into the public domain due to a breach of\nthese Terms and Conditions or some other obligation of confidentiality;"
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "about-unifi-para font-w400" },
                          [
                            _c(
                              "span",
                              { staticStyle: { "margin-left": "20px" } },
                              [
                                _vm._v(
                                  "ii. that is already lawfully in Your possession without restriction, before it was\ndisclosed by UNIFI; or"
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "about-unifi-para font-w400" },
                          [
                            _c(
                              "span",
                              { staticStyle: { "margin-left": "20px" } },
                              [
                                _vm._v(
                                  "iii. that You obtained lawfully from a third party, without any breach of confidentiality."
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "about-unifi-para font-w400" }, [
                  _c("span", [
                    _vm._v("• "),
                    _c("span", { staticClass: "font-w700 t-italic" }, [
                      _vm._v("GST")
                    ]),
                    _vm._v(
                      " means the tax payable on taxable supplies under the A New Tax System (Goods and\nServices Tax) Act 1999 (Cth), including any subordinate legislation."
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "about-unifi-para font-w400" }, [
                  _c("span", [
                    _vm._v("• "),
                    _c("span", { staticClass: "font-w700 t-italic" }, [
                      _vm._v("Intellectual Property Rights")
                    ]),
                    _vm._v(
                      " means all industrial and intellectual property rights anywhere in the\nworld, whether registered or unregistered, including patent rights, trade mark rights, copyright\n(but excluding Moral Rights), plant breeders’ rights and rights in relation to inventions, trade\nnames, business names, company names, indications of origin, designs, plant varieties,\nsemiconductors, circuit layouts, confidential information or know-how, any right of registration,\nrenewal and extension of such rights and all other intellectual property as defined in article 2 of\nthe Convention Establishing the World Intellectual Property Organisation 1967."
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "about-unifi-para font-w400" }, [
                  _c("span", [
                    _vm._v("• "),
                    _c("span", { staticClass: "font-w700 t-italic" }, [
                      _vm._v("Moral Rights")
                    ]),
                    _vm._v(
                      " means moral rights as described in Part IX of the Copyright Act 1968 (Cth) and any\nanalogous rights arising under statute that exist, or may come to exist, anywhere in the world."
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "about-unifi-para font-w400" }, [
                  _c("span", [
                    _vm._v("• "),
                    _c("span", { staticClass: "font-w700 t-italic" }, [
                      _vm._v("Personal Information")
                    ]),
                    _vm._v(
                      " means information or an opinion about an identified individual, or\ninformation from which an individual could reasonably be identified. This is regardless of\nwhether the information or opinion is true, and whether or not it is stored in a material or\nintangible form."
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "about-unifi-para font-w400" }, [
                  _c("span", [
                    _vm._v("• "),
                    _c("span", { staticClass: "font-w700 t-italic" }, [
                      _vm._v("Privacy Policy")
                    ]),
                    _vm._v(
                      " means the privacy policy of UNIFI as displayed on this Website from time to time."
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "about-unifi-para font-w400" }, [
                  _c("span", [
                    _vm._v("• "),
                    _c("span", { staticClass: "font-w700 t-italic" }, [
                      _vm._v("Property Platform")
                    ]),
                    _vm._v(
                      " means the electronic platform which allows the consumer and Referral\nPartners with a valid Referral Account to access information on Available Properties, including: "
                    )
                  ]),
                  _vm._v(" "),
                  _c("ul", [
                    _c("li", { staticClass: "about-unifi-para font-w400" }, [
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v("a) purchase prices;")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "about-unifi-para font-w400" }, [
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v("b) dimensions, land size and floor plans; and")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "about-unifi-para font-w400" }, [
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v(
                          "c) a description of the Available Property features. "
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "about-unifi-para font-w400" }, [
                  _c("span", [
                    _vm._v("• "),
                    _c("span", { staticClass: "font-w700 t-italic" }, [
                      _vm._v("Prospective Property Purchaser")
                    ]),
                    _vm._v(
                      " means an individual or entity interested in obtaining details of\nthe Available Properties, with a view to a possible purchase of one or more of them."
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "about-unifi-para font-w400" }, [
                  _c("span", [
                    _vm._v("• "),
                    _c("span", { staticClass: "font-w700 t-italic" }, [
                      _vm._v("Referral Account")
                    ]),
                    _vm._v(" means an online record of information:")
                  ]),
                  _vm._v(" "),
                  _c("ul", [
                    _c("li", { staticClass: "about-unifi-para font-w400" }, [
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v("a) created by a Referral Partner;")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "about-unifi-para font-w400" }, [
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v(
                          "b) containing the company name, Australian Business Number, street or PO Box address,\nemail address and telephone number of the Referral Partner; and"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "about-unifi-para font-w400" }, [
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v(
                          "c) which permits the Referral Partner to access details of Available Properties and to place\norders for Services."
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "about-unifi-para font-w400" }, [
                  _c("span", [
                    _vm._v("• "),
                    _c("span", { staticClass: "font-w700 t-italic" }, [
                      _vm._v("Referral Partner")
                    ]),
                    _vm._v(
                      " means a third party that may refer Prospective Property Purchasers to its CoAgent."
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "about-unifi-para font-w400" }, [
                  _c("span", [
                    _vm._v("• "),
                    _c("span", { staticClass: "font-w700 t-italic" }, [
                      _vm._v("Related Bodies Corporate")
                    ]),
                    _vm._v(
                      " has the same meaning as set out in the Corporations Act 2001 (Cth)."
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "about-unifi-para font-w400" }, [
                  _c("span", [
                    _vm._v("• "),
                    _c("span", { staticClass: "font-w700 t-italic" }, [
                      _vm._v("Reservation")
                    ]),
                    _vm._v(
                      " means an agreement formed upon processing of the Reservation Fee, under which a\nProspective Property Purchaser reserves an Available Property from viewing by other Referral\nPartners on the Property Platform, for the Reservation Period."
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "about-unifi-para font-w400" }, [
                  _c("span", [
                    _vm._v("• "),
                    _c("span", { staticClass: "font-w700 t-italic" }, [
                      _vm._v("Reservation Fee")
                    ]),
                    _vm._v(
                      " e means the fee paid by or on behalf of a Prospective Property Purchaser to\nsecure a Reservation."
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "about-unifi-para font-w400" }, [
                  _c("span", [
                    _vm._v("• "),
                    _c("span", { staticClass: "font-w700 t-italic" }, [
                      _vm._v("Reservation Period")
                    ]),
                    _vm._v(
                      " means a period of seven (7) days from the payment of the Reservation Fee, or\nsuch longer period as may be agreed between You and UNIFI. The reservation fee is fully refunded to the consumer after a 7 day holding period. Please note that it may take 3-5 business\ndays for the reimbursed funds to clear in your account. Any additional transactional fee for\ndomestic and international cards is a non-refundable fee."
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "about-unifi-para font-w400" }, [
                  _c("span", [
                    _vm._v("• "),
                    _c("span", { staticClass: "font-w700 t-italic" }, [
                      _vm._v("Services")
                    ]),
                    _vm._v(" means any of: ")
                  ]),
                  _vm._v(" "),
                  _c("ul", [
                    _c("li", { staticClass: "about-unifi-para font-w400" }, [
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v("a) a Reservation; ")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "about-unifi-para font-w400" }, [
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v(
                          "b) training materials, modules or activities accessible from our Website from time to time;\nand "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "about-unifi-para font-w400" }, [
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v(
                          "c) any other services which may be purchased or made available from this Website from\ntime to time. "
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "about-unifi-para font-w400" }, [
                  _c("span", [
                    _vm._v("• "),
                    _c("span", { staticClass: "font-w700 t-italic" }, [
                      _vm._v("Terms and Conditions")
                    ]),
                    _vm._v(
                      " means residential or commercial properties offered for sale Prospective\nProperty Purchasers by Agents, as agents of the registered proprietors of those properties."
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "about-unifi-para font-w400" }, [
                  _c("span", [
                    _vm._v("• "),
                    _c("span", { staticClass: "font-w700 t-italic" }, [
                      _vm._v("Third Party Fees")
                    ]),
                    _vm._v(
                      " means the fees described in paragraph (f) of the PLACEMENT OF\nRESERVATIONS AND PURCHASE OF OTHER SERVICES FROM OUR WEBSITE section of these\nTerms and Conditions. "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "about-unifi-para font-w400" }, [
                  _c("span", [
                    _vm._v("• "),
                    _c("span", { staticClass: "font-w700 t-italic" }, [
                      _vm._v("Website")
                    ]),
                    _vm._v(
                      " means the website situated at unifiproperty.com and includes the Property Platform. "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "about-unifi-para font-w400" }, [
                  _c("span", [
                    _vm._v("• "),
                    _c("span", { staticClass: "font-w700 t-italic" }, [
                      _vm._v("You")
                    ]),
                    _vm._v(
                      " means any of a Consumer, Referral Partner or other third party that accesses our Website,\nas the context requires and Your or Yourself has a corresponding meaning."
                    )
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  {
                    staticClass: "about-unifi-para font-w400 mt-12 t-underline"
                  },
                  [_vm._v("USE OF THIS WEBSITE\n          ")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v("You may only use this Website if You:")
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v("a) are aged 18 years or over;")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "b) are authorised by Prospective Property Purchasers to create a Reservation of Available\nProperties on their behalf; and"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "c) agree to be bound by, and accept, these Terms and Conditions."
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "Please immediately exit this Website if You do not satisfy these requirements."
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  {
                    staticClass: "about-unifi-para font-w400 mt-12 t-underline"
                  },
                  [
                    _vm._v(
                      "PLACEMENT OF RESERVATIONS AND PURCHASE OF OTHER SERVICES FROM OUR WEBSITE\n          "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v("You agree that: ")
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "a) both You and any Prospective Property Purchaser for whom you act are aged 18 years or over;"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "b) if You place a Reservation or an order for Services on our Website, You enter into a contract with\nUNIFI for the supply of the Reservation or those Services. Each accepted order is a separate\ncontract; "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "c) we can accept or reject a Reservation or order for Services for reasons which include\nunavailability of the Available Properties or Services (as the case may be), an error in the pricing\nor description of the Available Properties or Services, or an error in Your Reservation or order for\nthe Services;"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "d) Creating a Account; placing a Reservation; or ordering any Services, must be accurate, complete\nand up to date, and You will promptly notify us of any changes to this information or data; "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "e) all prices quoted for the Reservation Fee or Services are displayed in Australian Dollars (AUD)\nand are inclusive of GST;"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "f) once You have placed Your Reservation or order for Services, You may effect payment by either\nMastercard or Visa. Please note that by using the payment facilities provided by third party ecommerce facilities or credit card merchants, You will be subject to additional terms, conditions,\nfees and charges imposed by those third parties;"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "g) the payment system on this Website uses industry standard Secure Socket Layer (SSL)\ntechnology to encrypt and protect Your credit card details"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "h) we will provide Your Reservation or Services after Your payment has been processed. For the\navoidance of doubt, we do not offer for sale, or sell Available Properties, but simply make them\navailable for viewing on our Property Platform; "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "i) we will use our reasonable endeavours to ensure that Available Properties are available for\npurchase or Services are available for delivery, and in most cases the referral partner will notify\nYou if Available Properties are no longer available before You place Your Reservation, or Services\nare unavailable before You order them. In some cases, this will not be possible and we will need\nto reject a Reservation for Available Properties or an order for Services after we have processed\nYour payment. In these cases, we will refund You in full all amounts You have paid for the\nReservation or unavailable Services, less the Third Party Fees; "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "j) if you cancel Your Reservation before the Reservation Period expires, we will refund the\nReservation Fee to You, less the Third Party Fees; "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "k) once the Services have been delivered, You assume all risk and title in the Services."
                      )
                    ])
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  {
                    staticClass: "about-unifi-para font-w400 mt-12 t-underline"
                  },
                  [_vm._v("THIRD PARTY LINKS AND ADVERTISING\n          ")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "Our platform often includes advertisements, hyperlinks and pointers to websites operated by third\nparties. Links to third party websites include, without limitation, links to our platform or some of our real\nestate agency customers. Those third party websites do not form part of our platform and are not under\nthe control of or the responsibility of UNIFI. When you link to those websites you leave our platform and\ndo so entirely at your own risk. UNIFI and its related entities make no warranty as to the accuracy or\nreliability of the information contained on any third party websites, and UNIFI and its related entities,\ndirectors, officers and agents disclaim all liability and responsibility for any direct or indirect loss or\ndamage which may be suffered by you through relying on anything contained on or omitted from such\nthird party websites. A display of advertising does not imply an endorsement or recommendation by\nUNIFI."
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  {
                    staticClass: "about-unifi-para font-w400 mt-12 t-underline"
                  },
                  [_vm._v("CONTRIBUTIONS\n          ")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "In this section ‘Contributions’, means information including data, text, video, still images, audio or other\nmaterial that UNIFI has permitted you to host, share, publish, post, store or upload on our platform as\npermitted under these terms. UNIFI may at any time, without liability to you, remove, alter or disable\naccess to any or all of your Contributions in its sole discretion without prior notice to you. "
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "about-unifi-para font-w400 mt-10" },
                  [
                    _vm._v(
                      "Without limiting the previous sentence, UNIFI may remove or disable access to any or all your\nContributions if it considers that:"
                    )
                  ]
                ),
                _vm._v(" "),
                _c("ul", [
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "a) those Contributions are in breach of any law or regulation;"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "b) those Contributions infringe the intellectual property rights of any third party;"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "c) it is required to do so by a regulatory body or any relevant authority pursuant to an interim or\nfinal take-down notice;"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v("d) those Contributions are: ")
                    ]),
                    _vm._v(" "),
                    _c("ul", [
                      _c("li", { staticClass: "about-unifi-para font-w400" }, [
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v("i. misleading or deceptive;")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "about-unifi-para font-w400" }, [
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(
                            "ii. inappropriate having regard to the purpose of our platform;"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "about-unifi-para font-w400" }, [
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v("iii. likely to cause offence;")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "about-unifi-para font-w400" }, [
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v("iv. materially incorrect;")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "about-unifi-para font-w400" }, [
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v("v. obscene;")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "about-unifi-para font-w400" }, [
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v("vi. defamatory;")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "about-unifi-para font-w400" }, [
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v("vii. otherwise unlawful; or")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "about-unifi-para font-w400" }, [
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(
                            "viii. corrupted, due to the presence of a virus or other disabling code."
                          )
                        ])
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "You retain all of your ownership rights in your Contributions. UNIFI is under no obligation to treat your\nContributions as proprietary information."
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "To the extent that any Contributions are proprietary in nature, you grant UNIFI a worldwide, nonexclusive,\nroyalty-free, perpetual, transferable and irrevocable licence to use, reproduce, modify, adapt, translate,\ndistribute, publish, create derivative works from and display and publicly perform your Contributions\nthroughout the world in any medium, whether currently in existence or not. You also grant each user of\nour platform a nonexclusive licence to use, reproduce, adapt, translate, distribute, prepare derivative\nworks of, display and perform your Contributions as permitted by UNIFI and these terms. "
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "You grant UNIFI, in respect of Contributions to its website the right to use your name or the name you\nsubmit with the Contribution, and, the right to represent and warrant that: "
                  )
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "a) you own and control all of the rights to the Contributions; or "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "b) you have the lawful right including all necessary licences, rights, consents, and permissions to\nuse and authorise UNIFI to display the Contributions. "
                      )
                    ])
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "For any Contributions that you may retain moral rights in, you declare that:"
                  )
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "a) you do not require that any personally identifying information be used in connection with the\nContribution, or any derivative work, upgrade or update of the Contribution; and "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "b) You understand that when accessing our platform, you may be exposed to the Contributions of\nother users of our platform. You acknowledge and agree that UNIFI does not have control of and\nis not responsible for these other Contributions. You release UNIFI from any claims that you\ncould assert against UNIFI relating to or in connection with these other Contributions. "
                      )
                    ])
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v("You represent and warrant that: ")
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "a) you have the lawful right including all necessary licences, rights, consents, and permissions to\nuse and authorise UNIFI to display your Contributions; and "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v("b) you will not make any Contributions that: ")
                    ]),
                    _vm._v(" "),
                    _c("ul", [
                      _c("li", { staticClass: "about-unifi-para font-w400" }, [
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(
                            "i. infringe the intellectual property rights of any third party, and you agree to pay all\nroyalties, fees or other monies payable by reason of any Contributions made by\nyou; "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "about-unifi-para font-w400" }, [
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v("ii. are misleading or deceptive;")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "about-unifi-para font-w400" }, [
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v("iii. are materially incorrect;")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "about-unifi-para font-w400" }, [
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v("iv. are likely to cause offence;")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "about-unifi-para font-w400" }, [
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(
                            "v. directly or indirectly involve the advertising or marketing of any products or\nservices;"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "about-unifi-para font-w400" }, [
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(
                            "vi. are obscene, including pornographic, hateful, racially or ethnically offensive\nmaterial;"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "about-unifi-para font-w400" }, [
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v("vii. are defamatory;")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "about-unifi-para font-w400" }, [
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(
                            "viii. are otherwise unlawful or encourage unlawful conduct; or"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "about-unifi-para font-w400" }, [
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(
                            "ix. are otherwise inappropriate having regard to the purpose of our platform."
                          )
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  {
                    staticClass: "about-unifi-para font-w400 mt-12 t-underline"
                  },
                  [_vm._v("YOUR REFERRAL ACCOUNT\n          ")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "When placing Reservations or purchasing Services via this Website, You will need to create a Referral\nAccount with us. "
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v("To create a Referral Account, You must: ")
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "a) be aged 18 years or over and have the capacity to enter into a binding legal agreement to create a\nReferral Account with us; "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "b) provide us with, amongst other matters, Your company name, Australian Business Number,\nstreet or PO Box address, email address and telephone number. All Personal Information that we\nreceive from You is handled in accordance with the practices set out in our Privacy Policy which\nis accessible from this Website; and "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "c) create a password and username at the time that You register a Referral Account with us. You\nare responsible for maintaining the security of Your username and password. If You suspect that\nYour account has been subject to unauthorised access, You must contact us immediately and\ntake reasonable steps to secure Your account, such as changing Your password. We are not\nliable for any Claims howsoever arising from the unauthorised use of Your password or\nusername."
                      )
                    ])
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "We reserve the right to terminate or suspend Your account in the event that you breach these Terms and\nConditions."
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  {
                    staticClass: "about-unifi-para font-w400 mt-12 t-underline"
                  },
                  [_vm._v("YOUR PERSONAL INFORMATION AND PRIVACY\n          ")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "Our Privacy Policy sets out the ways in which we may collect, store, use and manage Your Personal\nInformation, and the physical and electronic measures we will take to protect Your Personal Information.\nBy supplying us with Personal Information through this Website, You accept the inherent security risk of\ndealings online over the internet and agree not to hold us responsible for any breach of security, unless\nwe have breached a law or been in wilful default of our duties to You. "
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  {
                    staticClass: "about-unifi-para font-w400 mt-12 t-underline"
                  },
                  [_vm._v("OUR INTELLECTUAL PROPERTY RIGHTS\n          ")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "Unless expressly stated otherwise, we own or are licensed to use all Intellectual Property Rights in this\nWebsite and its content. You may only use that content with our express written consent or as permitted\nunder applicable Australian and international laws. If we allow You to use any of the content appearing on\nthis Website, our status as the owner or licensee of the Intellectual Property Rights in that content must\nbe publicly acknowledged in writing, as we may direct. In that respect, You must not:"
                  )
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "a) adapt, modify, reproduce or transmit any of the Website content (including its graphics, layouts\nand format) without our prior written consent; "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "b) frame our Website content within Your own website, without our prior written consent; "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "c) download our Website content for any purpose other than referring Prospective Property\nPurchasers or its Co-Agent. "
                      )
                    ])
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "We do not own or license, and we take no responsibility for trade marks, logos, design and copyright\nmaterial appearing in:"
                  )
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "a) any third party websites which may be accessible from links displayed on our Website; or"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v("b) content that You provide to us. ")
                    ])
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  {
                    staticClass: "about-unifi-para font-w400 mt-12 t-underline"
                  },
                  [_vm._v("COPYRIGHT\n          ")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "The subject matter on and accessible from our platform and publications is protected by copyright. Apart\nfrom fair dealing permitted by the Copyright Act 1968, UNIFI grants visitors to the site permission to\ndownload copyright material only for private and non-commercial purposes. For reproduction or use of\nunifiproperty.com copyright material beyond such use, written permission must be obtained directly\nfrom UNIFI or the relevant copyright owner. If given, permission will be subject to the requirement that the copyright owner’s name and interest in the material be acknowledged when the material is\nreproduced or quoted, in whole or in part."
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  {
                    staticClass: "about-unifi-para font-w400 mt-12 t-underline"
                  },
                  [_vm._v("CONFIDENTIAL INFORMATION\n          ")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "Some sections of this Website, including the Property Platform, contain Confidential Information. By\naccessing this Website, You acknowledge and agree that:"
                  )
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "a) we are providing You with access to the Confidential Information to facilitate Your referral of\nProspective Property Purchasers, referral partners or its Co-Agents; "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "b) You will not use or disclose the Confidential Information for any other purpose, including to:"
                      )
                    ]),
                    _vm._v(" "),
                    _c("ul", [
                      _c("li", { staticClass: "about-unifi-para font-w400" }, [
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(
                            "i. improperly gain an advantage for Yourself or someone else;"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "about-unifi-para font-w400" }, [
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(
                            "ii. cause detriment to UNIFI Australia, Referral Partners or its Co-Agent; "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "about-unifi-para font-w400" }, [
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(
                            "iii. solicit, canvass or approach any of the registered proprietors of the Available\nProperties, so as to induce them to cease the appointment of UNIFI or its Referral\nPartners and CoAgents;"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "about-unifi-para font-w400" }, [
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(
                            "iv. interfere with the relationship between registered proprietors of the Available\nProperties and UNIFI or its Referral Partners and Co-Agent; and"
                          )
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "c)  the restrictions and prohibitions outlined in this section are reasonable in the circumstances and\nnecessary to protect the goodwill in UNIFI’s, Referral Partners and its Co-Agent’s business; and"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "d) monetary damages alone are not an adequate remedy for breach of this section and UNIFI may\napply for injunctive relief if You breach or threaten to breach this section. "
                      )
                    ])
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  {
                    staticClass: "about-unifi-para font-w400 mt-12 t-underline"
                  },
                  [_vm._v("CONTENT WE PROVIDE\n          ")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("li", { staticClass: "about-unifi-para font-w400" }, [
                  _c("span", [
                    _vm._v(
                      "Unless stated otherwise, we grant to You a personal, nontransferable, revocable and non-exclusive\nlicence to use any files that we expressly state is available for download on this Website, for Your own\npersonal use. Unless permitted by a written agreement between You and us, You must not copy,\ncommunicate to the public, modify, reverse engineer, or otherwise transfer any right in those files. We\ncannot guarantee that information (including any file) obtained from this Website is free from computer\nviruses, other faults or defects. It is Your responsibility to scan the information for computer viruses and\nYou assume the risk of any damage to Your computer and associated equipment arising from the use of\nthis Website or the downloading of any files from it. "
                    )
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  {
                    staticClass: "about-unifi-para font-w400 mt-12 t-underline"
                  },
                  [_vm._v("CONTENT YOU PROVIDE\n          ")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("li", { staticClass: "about-unifi-para font-w400" }, [
                  _c("span", [
                    _vm._v(
                      "You are fully responsible for any content (including any testimonials, comments, suggestions, graphics or\nother material) that You provide to us for display on the Website. By providing content to us, You grant us\na licence to use that content without payment or reference to You, for purposes which include advertising\nor marketing our own business and services."
                    )
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("li", { staticClass: "about-unifi-para font-w400" }, [
                  _c("span", [
                    _vm._v(
                      "You agree that You will not use this Website to post or display content that: "
                    )
                  ]),
                  _vm._v(" "),
                  _c("ul", [
                    _c("li", { staticClass: "about-unifi-para font-w400" }, [
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v(
                          "a) You do not have the right to post or display;"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "about-unifi-para font-w400" }, [
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v(
                          "b) violates the Intellectual Property Rights, confidentiality, privacy or other rights of any person or\nentity;"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "about-unifi-para font-w400" }, [
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v(
                          "c) violates consumer protection or fair trading laws; "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "about-unifi-para font-w400" }, [
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v(
                          "d) is offensive, abusive, defamatory, discriminatory, false or misleading; "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "about-unifi-para font-w400" }, [
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v(
                          "e) comprises advertising or promotional materials of any kind; or "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "about-unifi-para font-w400" }, [
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v(
                          "f) contains software viruses or anything harmful to this Website or to the computers, mobile\ndevices or associated equipment of other users of this Website. "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "We reserve the right to edit or remove any of Your content at any time, without providing any reasons. "
                    )
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  {
                    staticClass: "about-unifi-para font-w400 mt-12 t-underline"
                  },
                  [_vm._v("LINKS TO EXTERNAL WEBSITES\n          ")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "Our Website may contain links to Websites or advertisements of goods and services available from third\nparties. We are not responsible for the content of those Websites or advertisements, or any goods or\nservices made available on them."
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  {
                    staticClass: "about-unifi-para font-w400 mt-12 t-underline"
                  },
                  [_vm._v("SOCIAL MEDIA\n          ")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "We maintain a presence on Facebook, Instagram, LinkedIn and X, but are not endorsed by, or affiliated\nwith, those organisations (Social Media Accounts)."
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "We reserve the right to remove any material that is posted on the pages of our Social Media Accounts\nthat:"
                  )
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "a) is abusive, defamatory, offensive or threatening towards us, our employees or any other person\nor organisation; "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "b) breaches the terms and conditions of any of the providers of the Social Media Accounts;"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "c) constitutes spruiking or other advertising, unless written consent has been obtained from us to\npost such material; or "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v("d) relates to any illegal activity. ")
                    ])
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "Please note that You will be subject to, and agree to comply with, the respective terms and conditions\nimposed by Facebook, Instagram, LinkedIn, X and Twitter whilst You are visiting any of our Social Media\nAccounts and it remains Your responsibility to familiarise Yourself with those terms and conditions. "
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "By embedding an X timeline on our Website, X is granted a non-exclusive, royalty free licence to access,\nindex and cache this Website by any means, including web spiders and/or crawlers. X use of cookies may\ninvolve the storing and accessing of cookies or other information on Your devices, as described in Xs\nCookie Use Policy. You should consider X’s Cookies Use Policy before using our Website, which can be\nviewed via: "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://help.x.com/en/rules-and-policies/x-cookies"
                      }
                    },
                    [
                      _vm._v(
                        "https://help.x.com/en/rules-and-policies/x-cookies"
                      )
                    ]
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "X’s use of cookies may result in X collecting and storing data about Your browsing activities, including for\ninterest based advertising. By proceeding to use our Website, You consent to X’s use of cookies. You may\nopt out of X’s interest-based advertising and personalisation in accordance with the instructions\n              contained in its X for Websites — ads info and privacy document, accessible via: "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://help.x.com/en/xfor-websites-ads-info-and-privacy"
                      }
                    },
                    [
                      _vm._v(
                        "https://help.x.com/en/xfor-websites-ads-info-and-privacy"
                      )
                    ]
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  {
                    staticClass: "about-unifi-para font-w400 mt-12 t-underline"
                  },
                  [_vm._v("LIMITATION OF LIABILITY\n          ")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "To the maximum extent permitted by law, including the Australian Consumer Law: "
                  )
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "a) we provide this Website on an “as is” basis. We may suspend access to our Website or close it\nindefinitely without notice and You accept the inherent security and reliability risks of dealings on\nthe internet;"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "b) we are not liable for loss of revenue, loss of actual or anticipated profits, loss of business or\nindirect and consequential losses;"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "c) we are not liable for a breach of our obligations under these Terms and Conditions which has\nresulted from causes beyond our reasonable control. Those causes include extreme weather\nconditions, government restrictions, declared epidemics or pandemics, industrial strikes and\nfailure of equipment or machinery, including failure of the internet; and"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "about-unifi-para font-w400" }, [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "d) subject to the Australian Consumer Law (and without excluding any mandatory statutory\nguarantees contained within the Australian Consumer Law or other statutory rights which cannot\nbe excluded by contract) all conditions, warranties and implied terms are excluded from these\nTerms and Conditions. To the extent that we breach these Terms and Conditions and it is legally\npermissible to do so, our liability is limited to:"
                      )
                    ]),
                    _vm._v(" "),
                    _c("ul", [
                      _c("li", { staticClass: "about-unifi-para font-w400" }, [
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(
                            "i. replacement of the Services supplied or supply of equivalent Services;"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "about-unifi-para font-w400" }, [
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(
                            "ii. payment of the cost of replacing the Services or acquiring equivalent Services;"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "about-unifi-para font-w400" }, [
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v("iii. supply of the Services again; or")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "about-unifi-para font-w400" }, [
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(
                            "iv. in the case of Reservations, a refund of the Reservation Fee, less the Third Party\nFees. "
                          )
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "We will take all reasonable steps to ensure that this Website is accurate, but make no representation as\nto the appropriateness of it for Your personal circumstances."
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  {
                    staticClass: "about-unifi-para font-w400 mt-12 t-underline"
                  },
                  [_vm._v("NOTICES\n          ")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "We may give notice to You by electronic mail or by regular mail to the address contained in Your Referral\nAccount or other information You have provided. Our Privacy Policy explains how You can opt-out of\nreceiving such notices."
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  {
                    staticClass: "about-unifi-para font-w400 mt-12 t-underline"
                  },
                  [_vm._v("GOVERNING LAW\n          ")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px", "margin-left": "10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "about-unifi-para font-w400" }, [
                  _vm._v(
                    "The laws of South Australia, Australia, govern these Terms and Conditions and the courts of South\nAustralia have non-exclusive jurisdiction to hear any matters arising from or in connection with these\nTerms and Conditions."
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-000130c9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-000130c9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/terms/termsAndConditionsContent.vue
// module id = null
// module chunks = 